/* Rasterising a generated PDF for on-screen preview.

   This deliberately renders the real PDF rather than mocking the layout in
   HTML: what you see is the file that goes to the printer. */

import * as pdfjs from 'pdfjs-dist/build/pdf.mjs';

pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.mjs';

/* pdf.js refuses to run two renders against one canvas, and says so with an
   exception rather than queueing. Toggling a badge field re-renders the preview
   while the previous pass may still be going, so the earlier task is cancelled
   before a new one starts — the last request is the one anybody wants to see. */
const inFlight = new WeakMap();

export async function renderPdfToCanvas(bytes, canvas, {
  page = 1, scale = 2, maxWidth = 700,
} = {}) {
  inFlight.get(canvas)?.cancel();

  const doc = await pdfjs.getDocument({ data: bytes.slice() }).promise;
  const pg = await doc.getPage(Math.min(page, doc.numPages));
  let viewport = pg.getViewport({ scale });
  if (viewport.width > maxWidth) {
    viewport = pg.getViewport({ scale: scale * (maxWidth / viewport.width) });
  }
  canvas.width = Math.round(viewport.width);
  canvas.height = Math.round(viewport.height);
  canvas.style.width = Math.round(viewport.width / 2) + 'px';

  // Cancel again: awaiting the document above gives another call time to start.
  inFlight.get(canvas)?.cancel();
  const task = pg.render({ canvasContext: canvas.getContext('2d'), viewport });
  inFlight.set(canvas, task);
  try {
    await task.promise;
  } catch (err) {
    if (err?.name !== 'RenderingCancelledException') throw err;
    return;                       // superseded by a newer render; not a failure
  } finally {
    if (inFlight.get(canvas) === task) inFlight.delete(canvas);
    doc.destroy();
  }
}
